<template>
  <div>
    <div v-if="token.role === 'ADM'">
      <div class="row">
        <div class="col-6 col-md-3">
          <router-link tag="div" to="/admin/planos">
            <div class="card text-center" :class="isActive('/admin/planos')">
              <div class="card-body">
                <i class="material-icons icone">ballot</i>
                <p class="card-text">Planos</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link tag="div" to="/admin/empresas">
            <div class="card text-center" :class="isActive('/admin/empresas')">
              <div class="card-body">
                <i class="material-icons icone">business</i>
                <p class="card-text">Empresas</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link tag="div" to="/admin/usuarios">
            <div class="card text-center" :class="isActive('/admin/usuarios')">
              <div class="card-body">
                <i class="material-icons icone">account_box</i>
                <p class="card-text">Usuários</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-6 col-md-3">
          <router-link tag="div" to="/admin/eventos">
            <div class="card text-center" :class="isActive('/admin/eventos')">
              <div class="card-body">
                <i class="material-icons icone">event</i>
                <p class="card-text">Eventos</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <router-view></router-view>

    </div>

    <div v-if="token.role === 'CA'">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage';

export default {
  methods: {
    isActive(path) {
      const isIt = this.$route.fullPath.indexOf(path) > -1;
      return { 'bg-success': isIt, 'text-white': isIt };
    }
  }
};
</script>

<style scoped>
.icone {
  font-size: 50px;
  overflow: hidden;
}

.card {
  font-size: 10pt;
  cursor: pointer;
}

.col-6 {
  padding: 2px;
}
</style>





// WEBPACK FOOTER //
// src/components/app/admin/Home.vue